module.exports = __webpack_public_path__ + "img/submit.ca8b7589.png";